import { ReactNode, useState } from "react";

import {
  OnboardingConcernOptionEnum,
  OnboardingVariantIdType,
} from "@/domain/onboarding";
import {
  buildOnboardingI18nKey,
  OnboardingI18nPathType,
} from "@/utils/onboarding";

import { OnboardingContext } from "./OnboardingContext";

export const OnboardingProvider = ({
  variantId,
  children,
}: {
  variantId: OnboardingVariantIdType;
  children: ReactNode;
}) => {
  // Stays null until the user picks a concern; the next steps step shows the
  // "something else" copy for null, so skipping the choice or a variant with no
  // concerns step still reads correctly.
  const [selectedConcernOption, setSelectedConcernOption] =
    useState<OnboardingConcernOptionEnum | null>(null);

  const getI18nKey = (path: OnboardingI18nPathType) =>
    buildOnboardingI18nKey({ variantId, path });

  return (
    <OnboardingContext.Provider
      value={{
        variantId,
        selectedConcernOption,
        setSelectedConcernOption,
        getI18nKey,
      }}>
      {children}
    </OnboardingContext.Provider>
  );
};
